/**
 * The scene's measures, defined once. Every card size, gap and clearance the
 * map is drawn with comes from here; no layer has its own copy
 * (specs/workshop-modules/impact_path.md → "Rendering: one scene").
 */
export const SCENE_CONFIG = Object.freeze({
  cardWidth: 360,
  cardHeight: 90, // the smallest card; longer text makes it taller (cardHeightFor)
  columnGap: 340, // the gutter between two columns, where connectors turn
  rowGap: 40,
  laneGap: 200,
  // Text height, estimated from length so the scene stays DOM-free and deterministic.
  charsPerLine: 40,
  lineHeight: 18,
  cardChrome: 40, // kind label + padding above and below the text
  // Connector furniture.
  cornerRadius: 16,
  knotInset: 34, // knot this far before the arrow's end
  knotRadius: 8,
  labelHalfWidth: 48, // room a type label needs on either side of its point
  labelStep: 26, // one label height and a gap: labels of one source that would overlap step down their run by this
  labelGap: 10,
  linkSlot: 14, // links fan out around the gutter's centre line in steps of this
  inkSpacing: 0, // lines sharing a run sit this far apart (0: one line; 1: a ribbon as thick as their count — readable only once joins and exits are ordered, after 29.10.)
  curveSamples: 16, // points a freeform curve is sampled at
});

/** A card's height for its text: one rule for every card on the map. */
export function cardHeightFor(text, config = SCENE_CONFIG) {
  const len = String(text || '').trim().length;
  const lines = Math.max(1, Math.ceil(len / config.charsPerLine));
  const h = config.cardChrome + lines * config.lineHeight;
  return Math.max(config.cardHeight, Math.ceil(h / 2) * 2);
}
